import type { ContentType } from "@brookbush/database";
import type { Content } from "@brookbush/types";

import useSWR from "swr";

import fetcher from "~/utils/fetcher.client";

/**
 * Lazily resolves a chat content link to its card preview. The request is
 * disabled until `enabled` is true (i.e. the chip is hovered/focused), and SWR
 * dedupes by key so the same content referenced by multiple chips resolves once.
 *
 * The fetcher is passed explicitly rather than relying on the ambient
 * `SWRConfig`: the ChatWidget mounts as a sibling of `PageConfig` in `_app`, so
 * it lives OUTSIDE the `SWRConfig` provider and has no global fetcher in context.
 */
const useContentPreview = (
	type: ContentType,
	slug: string,
	enabled: boolean,
) => {
	const key =
		enabled && slug
			? `/content/preview?type=${type}&slug=${encodeURIComponent(slug)}`
			: null;

	const { data, isLoading } = useSWR<Content | null>(key, fetcher);

	return { content: data ?? undefined, isLoading };
};

export default useContentPreview;
